import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as Stickyfill from 'stickyfilljs';

import {
	IApply,
	ICareerSearchCondition,
	ISelectedCareer,
	setCareerSearchCondition,
	setCategorySelectedCareers,
	setDetailSelectedCareers,
} from '../actions/search';
import SearchCategory from '../containers/SearchCategory';
import SearchDetail, { SearchDetailTypes } from '../containers/SearchDetail';
import i18n from '../resources/i18n';
import { isMobile } from '../utils/MobileCheck';
import SearchSteper from './SearchSteper';

import { IRootState } from '../reducers';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		accessBar: {
			backgroundColor: '#e8eaf6',
			marginTop: theme.spacing(1),
			position: 'sticky',
			top: '0px',
			zIndex: 10,
		},
		appBar: {
			position: 'relative',
		},
		flex: {
			flex: 1,
		},
		main: {
			paddingLeft: '180px',
			paddingRight: '180px',
		},
		mobileHeader: {
			backgroundColor: '#e8eaf6',
			position: 'fixed',
			top: '58px',
			width: '100%',
			zIndex: 999,
		},
		mobileMain: {
			paddingLeft: '1px',
			paddingRight: '1px',
		},
		root: {
			padding: theme.spacing(1),
			position: 'relative',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IState {
	activeStep: number;
	selectFlg: boolean;
	show: boolean;
	tabNumber: number;
}

const initProps: ICareerSearchCondition = {
	assessment: false,
	careerIDs: [],
	careerType: '0',
	categoryId: '',
	categoryName: '',
	detail: [
		{
			__multiselectValues: [],
			__type: '',
			items: [],
			text: '',
			type: '',
		},
	],
	elearning: true,
	endDate: '',
	freeword: '',
	jobCategory: false,
	lowerFlg: false,
	office: false,
	onlyWanted: false,
	position: false,
	qualification: false,
	shugo: true,
	skillTypeList: [],
	sonota: false,
	startDate: '',
	tuusin: true,
	workExperience: false,
};

/**
 * 検索画面
 */
class SearchMain extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			activeStep: 0,
			selectFlg: false,
			show: true,
			tabNumber: 0,
		};

		this.onApply = this.onApply.bind(this);
	}

	public componentDidMount() {
		// 選択対象クリア
		this.props.setCategorySelectedCareers([]);
		this.props.setDetailSelectedCareers([]);
		this.props.setCareerSearchCondition(initProps);
	}

	public render() {
		const { classes } = this.props;
		return (
			<>
				{isMobile() && (
					<div
						style={{
							backgroundColor: '#e8eaf6',
							bottom: '0px',
							display: this.state.show ? 'flex' : 'none',
							justifyContent: 'center',
							position: 'fixed',
							width: '100%',
							zIndex: 999,
						}}
					>
						<Button
							variant="contained"
							color="primary"
							onClick={this.handleApply}
							style={{
								marginBottom: '10px',
								marginRight: '20px',
								marginTop: '5px',
							}}
						>
							{i18n.t('SearchMain_0001')}
						</Button>
					</div>
				)}
				<div className={classes.root}>
					{!isMobile() && (
						<>
							<div
								style={{
									display: this.state.show ? 'flex' : 'none',
									justifyContent: 'flex-end',
									left: '0px',
									position: 'absolute',
									top: '80px',
									width: '100%',
								}}
							>
								<Button
									variant="contained"
									color="primary"
									onClick={this.handleApply}
									style={{ marginRight: '20px' }}
								>
									{i18n.t('SearchMain_0001')}
								</Button>
							</div>
							<div className={classes.main}>
								<SearchSteper
									activeStep={this.state.activeStep}
								/>
								<Tabs
									value={this.state.tabNumber}
									onChange={this.handleChange}
									indicatorColor="primary"
									textColor="primary"
									centered={true}
								>
									<Tab label={i18n.t('SearchMain_0002')} />
									<Tab label={i18n.t('SearchMain_0003')} />
								</Tabs>
								{this.state.tabNumber === 0 && (
									<SearchCategory
										selectFlg={this.state.selectFlg}
										onSelectEnd={this.handleSelectEnd}
									/>
								)}
								{this.state.tabNumber === 1 && (
									<SearchDetail
										applyFlg={this.props.details.applyFlg}
										data={this.props.details.data}
										selectedCareers={
											this.props.details.selectedCareers
										}
										selectedColumns={
											this.props.details.selectedColumns
										}
										type={SearchDetailTypes.NORMAL}
										onApply={this.onApply}
										resultApply={false}
									/>
								)}
							</div>
						</>
					)}
					{isMobile() && (
						<>
							<div className={classes.mobileMain}>
								<Grid
									container={true}
									justify="center"
									className={classes.accessBar}
									ref={(el: HTMLDivElement) =>
										el && Stickyfill.add(el)
									}
								>
									<SearchSteper
										activeStep={this.state.activeStep}
									/>
									<Tabs
										value={this.state.tabNumber}
										onChange={this.handleChange}
										indicatorColor="primary"
										textColor="primary"
										centered={true}
									>
										<Tab
											label={i18n.t('SearchMain_0002')}
											wrapped={true}
										/>
										<Tab
											label={i18n.t('SearchMain_0003')}
											wrapped={true}
										/>
									</Tabs>
								</Grid>
								<div>
									{this.state.tabNumber === 0 && (
										<div
											style={{
												marginBottom: '50px',
											}}
										>
											<SearchCategory
												selectFlg={this.state.selectFlg}
												onSelectEnd={
													this.handleSelectEnd
												}
											/>
										</div>
									)}
									{this.state.tabNumber === 1 && (
										<SearchDetail
											applyFlg={
												this.props.details.applyFlg
											}
											data={this.props.details.data}
											selectedCareers={
												this.props.details
													.selectedCareers
											}
											selectedColumns={
												this.props.details
													.selectedColumns
											}
											type={SearchDetailTypes.NORMAL}
											onApply={this.onApply}
											resultApply={false}
										/>
									)}
								</div>
							</div>
						</>
					)}
				</div>
			</>
		);
	}

	/**
	 * 詳細検索の申請処理
	 * @param applies 申請情報
	 * @param careerType キャリアタイプ
	 */
	protected onApply(applies: IApply[], careerType: string) {
		const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
		const condition = {
			applies,
			caller: window.location.pathname,
			careerType,
		};
		this.props.pushHistory(to, condition);
	}

	/**
	 * タブ変更ハンドラ
	 */
	protected handleChange = (event: React.ChangeEvent<{}>, value: any) => {
		// 同一タブなら遷移しない
		if (value !== this.state.tabNumber) {
			this.props.setCategorySelectedCareers([]);
			this.props.setDetailSelectedCareers([]);
			this.props.setCareerSearchCondition(initProps);
		}
		this.setState({
			activeStep: value === 0 ? 0 : 1,
			selectFlg: false,
			show: value === 0 ? true : false,
			tabNumber: value,
		});
	};

	/**
	 * クラス・実施期間選択
	 */
	protected handleApply = (e: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectFlg: !this.state.selectFlg,
		});
	};

	/**
	 * 「選択」ボタンをクリックする。
	 */
	protected handleSelectEnd = (result: any) => {
		this.setState({ selectFlg: false });
	};
}

const mapStateToProps = (state: IRootState) => ({
	condition: state.search.careerSearchCondition,
	details: state.search.details,
	isOpenApprovalTargetCheck: state.search.isOpenApprovalTargetCheck,
	isOpenApprovals: state.search.isOpenApprovals,
	setCategoryAt: state.search.setCategoryAt,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (path: string, state?: any) => dispatch(push(path, state)),
	setCareerSearchCondition: (value: ICareerSearchCondition) =>
		dispatch(setCareerSearchCondition({ value })),
	setCategorySelectedCareers: (selectedCareers: ISelectedCareer[]) =>
		dispatch(setCategorySelectedCareers({ selectedCareers })),
	setDetailSelectedCareers: (selectedCareers: ISelectedCareer[]) =>
		dispatch(setDetailSelectedCareers({ selectedCareers })),
});

// tslint:disable-next-line:no-empty-interface
export interface ISearchMainProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISearchMainProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SearchMain);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/SearchMain.tsx